import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    images: {
        defaultMessage: 'Images',
        id: 'iaso.label.images',
    },
    files: {
        defaultMessage: 'Files',
        id: 'iaso.instance.files',
    },
    create: {
        defaultMessage: 'Create',
        id: 'iaso.label.create',
    },
    newOrgUnit: {
        defaultMessage: 'Create an org unit',
        id: 'iaso.orgUnits.new',
    },
    action: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    multiEditTitle: {
        defaultMessage: 'Edit selection',
        id: 'iaso.orgUnits.multiEditTitle',
    },
    confirmMultiChange: {
        defaultMessage: 'Confirm mass changes ?',
        id: 'iaso.orgUnits.confirmMultiChange',
    },
    editGroups: {
        defaultMessage: 'Edit groups',
        id: 'iaso.orgUnits.editGroups',
    },
    editOrgUnitType: {
        defaultMessage: 'Edit org unit type',
        id: 'iaso.orgUnits.editOrgUnitType',
    },
    validationStatus: {
        id: 'iaso.forms.validationStatus',
        defaultMessage: 'Validation status',
    },
    new: {
        id: 'iaso.forms.new',
        defaultMessage: 'new',
    },
    all: {
        id: 'iaso.forms.all',
        defaultMessage: 'All',
    },
    rejected: {
        id: 'iaso.forms.rejected',
        defaultMessage: 'rejected',
    },
    closed: {
        id: 'iaso.forms.closed',
        defaultMessage: 'Closed',
    },
    editValidation: {
        defaultMessage: 'Edit validation',
        id: 'iaso.orgUnits.editValidation',
    },
    validate: {
        defaultMessage: 'Validate',
        id: 'iaso.label.validate',
    },
    valid: {
        defaultMessage: 'Valid',
        id: 'iaso.label.valid',
    },
    validated: {
        id: 'iaso.forms.valid',
        defaultMessage: 'Valid',
    },
    notValidated: {
        id: 'iaso.forms.notValidated',
        defaultMessage: 'Not validated',
    },
    title: {
        defaultMessage: 'Org units',
        id: 'iaso.orgUnits.title',
    },
    titleSingle: {
        defaultMessage: 'org unit',
        id: 'iaso.orgUnits.titleSingle',
    },
    titleMulti: {
        defaultMessage: 'org units',
        id: 'iaso.orgUnits.titleMulti',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.label.search',
    },
    infos: {
        defaultMessage: 'Infos',
        id: 'iaso.label.infos',
    },
    history: {
        defaultMessage: 'History',
        id: 'iaso.label.history',
    },
    forms: {
        defaultMessage: 'Forms',
        id: 'iaso.label.forms',
    },
    list: {
        defaultMessage: 'List',
        id: 'iaso.label.list',
    },
    map: {
        defaultMessage: 'Map',
        id: 'iaso.label.map',
    },
    parents: {
        defaultMessage: 'Parents',
        id: 'iaso.orgUnits.parents',
    },
    parentsMulti: {
        defaultMessage: 'Parent(s)',
        id: 'iaso.orgUnits.parentsMulti',
    },
    org_unit_type: {
        id: 'iaso.forms.org_unit_type_id',
        defaultMessage: 'Org unit type',
    },
    orgUnitsTypes: {
        defaultMessage: 'Org unit types',
        id: 'iaso.label.orgUnitsTypes',
    },
    type: {
        defaultMessage: 'Type',
        id: 'iaso.orgUnits.type',
    },
    cancel: {
        defaultMessage: 'Cancel',
        id: 'iaso.label.cancel',
    },
    save: {
        defaultMessage: 'Save',
        id: 'iaso.label.save',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.orgUnits.name',
    },
    code: {
        defaultMessage: 'Code',
        id: 'iaso.orgUnits.code',
    },
    groups: {
        defaultMessage: 'Groups',
        id: 'iaso.label.groups',
    },
    group: {
        defaultMessage: 'Group',
        id: 'iaso.label.group',
    },
    addToGroups: {
        defaultMessage: 'Add to group(s)',
        id: 'iaso.orgUnits.addToGroups',
    },
    removeFromGroups: {
        defaultMessage: 'Remove from group(s)',
        id: 'iaso.orgUnits.removeFromGroups',
    },
    project: {
        defaultMessage: 'Project',
        id: 'iaso.orgUnits.project',
    },
    projects: {
        defaultMessage: 'Projects',
        id: 'iaso.label.projects',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.orgUnits.source',
    },
    sourceLower: {
        defaultMessage: 'source',
        id: 'iaso.orgUnits.sourceLower',
    },
    sourceRef: {
        defaultMessage: 'Source ref',
        id: 'iaso.orgUnits.sourceRef',
    },
    updated_at: {
        defaultMessage: 'Updated',
        id: 'iaso.label.updated_at',
    },
    created_at: {
        defaultMessage: 'Created',
        id: 'iaso.label.created_at',
    },
    creator: {
        defaultMessage: 'Created By',
        id: 'iaso.orgUnits.createdBy',
    },
    details: {
        defaultMessage: 'Details',
        id: 'iaso.label.details',
    },
    clear: {
        id: 'iaso.label.clear',
        defaultMessage: 'Clear',
    },
    date: {
        defaultMessage: 'Date',
        id: 'iaso.label.date',
    },
    user: {
        defaultMessage: 'User',
        id: 'iaso.label.user',
    },
    noOptions: {
        defaultMessage: 'No result found',
        id: 'iaso.label.noOptions',
    },
    display: {
        defaultMessage: 'Display',
        id: 'iaso.label.display',
    },
    resultsLower: {
        defaultMessage: 'result(s)',
        id: 'iaso.label.resultsLower',
    },
    searchOrgUnit: {
        defaultMessage: 'Search org unit',
        id: 'iaso.orgUnits.search',
    },
    color: {
        defaultMessage: 'Color',
        id: 'iaso.label.color',
    },
    missingGeolocation: {
        defaultMessage: 'Cannot find an org unit with geolocation',
        id: 'iaso.orgUnits.missingGeolocation',
    },
    subOrgUnitsType: {
        defaultMessage: 'Sub org units types',
        id: 'iaso.orgUnits.subOrgUnitsType',
    },
    subOrgUnitsTypeNoData: {
        defaultMessage: 'No sub org unit types',
        id: 'iaso.orgUnits.subOrgUnitsType.noData',
    },
    addOrgUnitType: {
        defaultMessage: 'Add org unit type',
        id: 'iaso.orgUnits.addOrgUnitType',
    },
    selectionAction: {
        defaultMessage: 'With selected org unit',
        id: 'iaso.orgUnits.selectionAction',
    },
    multiSelectionAction: {
        defaultMessage: 'Edit selected org units',
        id: 'iaso.orgUnits.multiSelectionAction',
    },
    status: {
        id: 'iaso.forms.status',
        defaultMessage: 'Status',
    },
    instances_count: {
        id: 'iaso.orgUnits.instances_count',
        defaultMessage: 'Number of submissions',
    },
    instances: {
        id: 'iaso.instance.title',
        defaultMessage: 'Submissions',
    },
    orgUnitInstances: {
        id: 'iaso.forms.records',
        defaultMessage: 'Submission(s)',
    },
    parent: {
        id: 'iaso.label.parent',
        defaultMessage: 'Parent',
    },
    latitude: {
        id: 'iaso.label.latitude',
        defaultMessage: 'Latitude',
    },
    altitude: {
        id: 'iaso.label.altitude',
        defaultMessage: 'Altitude',
    },
    longitude: {
        id: 'iaso.label.longitude',
        defaultMessage: 'Longitude',
    },
    associate: {
        id: 'iaso.label.useOrgUnitLocation.btn',
        defaultMessage: 'Use this location',
    },
    question: {
        id: 'iaso.label.useOrgUnitLocation.question',
        defaultMessage:
            'Are you sure you want to use this location for the current org unit ?',
    },
    message: {
        id: 'iaso.label.useOrgUnitLocation.message',
        defaultMessage: "Don't forget to save",
    },
    catchment: {
        id: 'iaso.map.catchment',
        defaultMessage: 'Catchment',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    stopEdit: {
        id: 'iaso.label.stopEdit',
        defaultMessage: 'Stop edit',
    },
    delete: {
        id: 'iaso.label.delete',
        defaultMessage: 'Delete',
    },
    stopDelete: {
        id: 'iaso.label.stopDelete',
        defaultMessage: 'Stop delete',
    },
    done: {
        id: 'iaso.label.done',
        defaultMessage: 'Done',
    },
    add: {
        id: 'iaso.label.add',
        defaultMessage: 'Add',
    },
    location: {
        id: 'iaso.label.location',
        defaultMessage: 'Location',
    },
    addLocation: {
        id: 'iaso.map.shape.addLocation',
        defaultMessage: 'Add a location',
    },
    editLocationDisabled: {
        id: 'iaso.map.shape.editLocationDisabled',
        defaultMessage: 'Location edition is disabled on this account',
    },
    editCatchmentDisabled: {
        id: 'iaso.map.shape.editCatchmentDisabled',
        defaultMessage: 'Catchment edition is disabled on this account',
    },
    deleteMarker: {
        id: 'iaso.map.marker.delete',
        defaultMessage: 'Delete marker',
    },
    children: {
        id: 'iaso.label.children',
        defaultMessage: 'Children',
    },
    links: {
        id: 'iaso.label.links',
        defaultMessage: 'Links',
    },
    comments: {
        id: 'iaso.label.comments',
        defaultMessage: 'Comments',
    },
    selectOrgUnit: {
        id: 'iaso.orgUnits.selectOrgUnit',
        defaultMessage: 'Please select an Org Unit',
    },
    ouTypesHelperText: {
        id: 'iaso.orgUnits.ouTypesHelperText',
        defaultMessage: 'Children org units',
    },
    statusNew: {
        id: 'iaso.orgUnits.statusNew',
        defaultMessage: 'Validation status: NEW',
    },
    statusValid: {
        id: 'iaso.orgUnits.statusValid',
        defaultMessage: 'Validation status: VALID',
    },
    statusRejected: {
        id: 'iaso.orgUnits.statusRejected',
        defaultMessage: 'Validation status: REJECTED',
    },
    bulkChangeCount: {
        id: 'iaso.orgUnits.bulkChangeCount',
        defaultMessage: 'You are about to change {count} Org units',
    },
    bulkChangeTaskHelp: {
        id: 'iaso.orgUnits.bulkChangeTaskHelp',
        defaultMessage:
            'The modification runs in the background and can take a few minutes.',
    },
    modifyAndFollow: {
        id: 'iaso.orgUnits.modifyAndFollow',
        defaultMessage: 'Modify and follow',
    },
    fetchAlgorithmsError: {
        id: 'iaso.snackBar.fetchAlgorithmsError',
        defaultMessage: 'An error occurred while fetching algorithms list',
    },
    fetchGroupsError: {
        id: 'iaso.snackBar.fetchGroupsError',
        defaultMessage: 'An error occurred while fetching groups list',
    },
    fetchGroupSetsError: {
        id: 'iaso.snackBar.fetchGroupSetsError',
        defaultMessage: 'An error occurred while fetching group sets list',
    },
    fetchProfilesError: {
        id: 'iaso.snackBar.fetchProfilesError',
        defaultMessage: 'An error occurred while fetching profiles list',
    },
    fetchOrgUnitTypesError: {
        id: 'iaso.snackBar.fetchOrgUnitTypesError',
        defaultMessage: 'An error occurred while fetching org unit types list',
    },
    fetchSourcesError: {
        id: 'iaso.snackBar.fetchSourcesError',
        defaultMessage: 'An error occurred while fetching sources list',
    },
    fetchOrgUnitError: {
        id: 'iaso.snackBar.fetchOrgUnitError',
        defaultMessage: 'An error occurred while fetching org unit detail',
    },
    saveOrgUnitError: {
        id: 'iaso.snackBar.saveOrgUnitError',
        defaultMessage: 'An error occurred while saving org unit',
    },
    saveOrgUnitSuccesfull: {
        id: 'iaso.snackBar.saveOrgUnitSuccesfull',
        defaultMessage: 'Org unit saved successfully',
    },
    saveLinkError: {
        id: 'iaso.snackBar.saveLinkError',
        defaultMessage: 'An error occurred while saving link',
    },
    showAdvancedSettings: {
        id: 'iaso.form.label.showAdvancedSettings',
        defaultMessage: 'Show advanced settings',
    },
    hideAdvancedSettings: {
        id: 'iaso.form.label.hideAdvancedSettings',
        defaultMessage: 'Hide advanced settings',
    },
    sourceVersion: {
        id: 'iaso.form.label.sourceVersion',
        defaultMessage: 'Source version',
    },
    ouParent: {
        id: 'iaso.label.parentOu',
        defaultMessage: 'Parent Org unit',
    },
    ouLinked: {
        id: 'iaso.orgUnits.sourcesHelperTextSingular',
        defaultMessage: 'Linked org unit',
    },
    ouChild: {
        id: 'iaso.orgUnits.ouTypesHelperTextSingular',
        defaultMessage: 'Children org unit',
    },
    ouCurrent: {
        id: 'iaso.label.currentOu',
        defaultMessage: 'Current org unit',
    },
    linkOrgUnitToInstanceReferenceTitle: {
        id: 'iaso.instance.dialog.linkOrgUnitToInstanceReferenceTitle',
        defaultMessage:
            'Are you sure you want to link this submission to the orgUnit as a reference one ?',
    },
    linkOffOrgUnitToInstanceReferenceTitle: {
        id: 'iaso.instance.dialog.linkOffOrgUnitToInstanceReferenceTitle',
        defaultMessage:
            'Are you sure you want to unlink this reference submission from the orgUnit ?',
    },
    linkOrgUnitToInstanceReferenceWarning: {
        id: 'iaso.instance.linkOrgUnitToInstanceReferenceWarning',
        defaultMessage: 'This operation can still be undone',
    },
    selectParentOrgUnit: {
        defaultMessage: 'Select parent Org Unit',
        id: 'iaso.label.selectParentOrgUnit',
    },
    org_unit_type_id: {
        id: 'iaso.forms.org_unit_type_id',
        defaultMessage: 'Org unit type',
    },
    ID: {
        defaultMessage: 'Identifier',
        id: 'iaso.label.id',
    },
    detailTitle: {
        defaultMessage: 'Form',
        id: 'iaso.instance.formShort',
    },
    downloadXml: {
        id: 'iaso.label.downloadXml',
        defaultMessage: 'Download XML',
    },

    anyGeography: {
        id: 'iaso.label.anyGeography',
        defaultMessage: 'With point or territory',
    },
    withLocation: {
        id: 'iaso.label.withLocation',
        defaultMessage: 'With point only',
    },
    withShape: {
        id: 'iaso.label.withShape',
        defaultMessage: 'With territory only',
    },
    noGeographicalData: {
        id: 'iaso.label.noGeographicalData',
        defaultMessage: 'Without geography',
    },
    geographicalData: {
        id: 'iaso.label.geographicalData',
        defaultMessage: 'Geographical data',
    },
    with: {
        id: 'iaso.label.with',
        defaultMessage: 'With',
    },
    without: {
        id: 'iaso.label.without',
        defaultMessage: 'Without',
    },
    duplicates: {
        id: 'iaso.label.duplicates',
        defaultMessage: 'Duplicates',
    },
    hasInstances: {
        id: 'iaso.forms.hasInstances',
        defaultMessage: 'Form submissions',
    },
    saveMultiEditOrgUnitsSuccesfull: {
        defaultMessage: 'Selected org unit saved successfully',
        id: 'iaso.snackBar.saveMultiEditOrgUnitsSuccesfull',
    },
    saveMultiEditOrgUnitsError: {
        defaultMessage: 'An error occurred while saving selected org units',
        id: 'iaso.snackBar.saveMultiEditOrgUnitsError',
    },
    saveMultiEditOrgUnitsLaunched: {
        defaultMessage:
            'The modifications to the org units will take a few minutes to take effect',
        id: 'iaso.snackBar.saveMultiEditOrgUnitsLaunched',
    },
    latitudeLongitude: {
        id: 'iaso.label.latitudeLongitude',
        defaultMessage: 'Latitude & Longitude',
    },
    hasGeometry: {
        id: 'iaso.label.hasGeometry',
        defaultMessage: 'With Geography',
    },
    hasNoGeometryAndGps: {
        id: 'iaso.label.hasNoGeometryAndGps',
        defaultMessage: 'Without geographic data',
    },
    depth: {
        id: 'iaso.orgUnits.depth',
        defaultMessage: 'Depth',
    },
    useGPSFromSubmission: {
        id: 'iaso.orgUnits.useGPSFromSubmission',
        defaultMessage: 'Use GPS coordinates from form submission',
    },
    GPSWarning: {
        id: 'iaso.orgUnits.GPSWarning',
        defaultMessage:
            'In case of multiple submissions for the same org unit, the average will be taken into account',
    },
    multiReferenceInstancesLabel: {
        id: 'iaso.orgUnits.MultiReferenceInstancesLabel',
        defaultMessage: 'Reference submissions',
    },
    openDate: {
        id: 'iaso.orgUnits.openDate',
        defaultMessage: 'Open on',
    },
    openingDate: {
        id: 'iaso.orgUnits.openingDate',
        defaultMessage: 'Opening date',
    },
    closingDate: {
        id: 'iaso.orgUnits.closingDate',
        defaultMessage: 'Closing date',
    },
    searchParams: {
        id: 'iaso.orgUnits.searchParams',
        defaultMessage:
            // eslint-disable-next-line max-len
            'Use prefix “refs:” for external org unit ID search, “ids:” for internal org unit ID search or “codes:” for org unit code search. You can also search multiple IDs at once, separated by a comma or a space. E.g. “ids: 123456, 654321”, “refs: O6uvpzGd5pu, ImspTQPwCqd” or “codes: OU420, OU69”',
    },
    textSearch: {
        id: 'iaso.forms.textSearch',
        defaultMessage: 'Text search',
    },
    shape: {
        id: 'iaso.forms.shape',
        defaultMessage: 'Shape',
    },
    onlyDirectChildren: {
        id: 'iaso.orgUnits.onlyDirectChildren',
        defaultMessage: 'Only Direct children',
    },
    default: {
        id: 'iaso.datasources.options.label.default',
        defaultMessage: 'default',
    },
    noResult: {
        id: 'iaso.label.noOptions',
        defaultMessage: 'No result found',
    },
    fetchLinksError: {
        id: 'iaso.snackBar.fetchLinksError',
        defaultMessage: 'An error occurred while fetching links list',
    },
    fitToOutBounds: {
        id: 'iaso.orgUnits.fitToOutBounds',
        defaultMessage: 'Fit map to children bounds',
    },
    searchToSeeOrgUnits: {
        id: 'iaso.forms.searchToSeeOrgUnits',
        defaultMessage: 'Click "Search" button to see org units',
    },
    addChild: {
        id: 'iaso.orgUnits.addChild',
        defaultMessage: 'Add child',
    },
    rejectOrgUnit: {
        id: 'iaso.orgUnits.rejectOrgUnit',
        defaultMessage: 'Reject Org Unit',
    },
    rejectOrgUnitQuestion: {
        id: 'iaso.orgUnits.rejectOrgUnitQuestion',
        defaultMessage:
            'Are you sure you want to reject this org unit: {name}?',
    },
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
    orgUnitRejected: {
        id: 'iaso.orgUnits.orgUnitRejected',
        defaultMessage: 'Org Unit rejected successfully',
    },
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
});

export default MESSAGES;
